<template>
  <div
    v-if="averageOrderCompletionTime.value"
    class="column text-black"
  >
    <span
      class="text-h6"
      style="line-height: 1;"
    >
      {{ averageOrderCompletionTime.value.minutes }}:{{ averageOrderCompletionTime.value.seconds }} minutes
    </span>
    <span
      class="text-caption"
      style="line-height: 1;"
    >
      Average Completion Time
    </span>
  </div>
</template>

<script>
export default {
  name: 'KitchenDisplayAverageOrderTime',
  props: {
    autoFetch: {
      type: Boolean,
      required: false,
      default: true
    },
    kitchenDisplay: {
      type: Object,
      required: true
    }
  },
  models: {
    averageOrderCompletionTime: {
      variables () {
        return {
          kitchenDisplayId: this.kitchenDisplay.id,
          skip: this.$register && !this.kitchenDisplay?.isRemote
        }
      },
      immediate: true
    }
  },
  watch: {
    autoFetch: {
      handler () {
        if (this.autoFetch) {
          this.setUpdateAverageDeliveryTimeInterval()
        } else {
          this.clearUpdateAverageDeliveryTimeInterval()
        }
      },
      immediate: true
    }
  },
  beforeUnmount () {
    this.clearUpdateAverageDeliveryTimeInterval()
  },
  methods: {
    async refresh () {
      if (this.averageOrderCompletionTime.options.skip) return

      await this.averageOrderCompletionTime.fetch(true)
    },
    setUpdateAverageDeliveryTimeInterval () {
      if (!this.updateAverageDeliveryTimeInterval) {
        this.updateAverageDeliveryTimeInterval = setInterval(async () => {
          try {
            await this.refresh()
          } catch (e) {
            this.$rollbar.error('KDS failed to fetch averageOrderCompletionTime in interval', e)
          }
        }, 1000 * 60 * 5) // Every 5 minutes
      }
    },
    clearUpdateAverageDeliveryTimeInterval () {
      if (this.updateAverageDeliveryTimeInterval) {
        clearInterval(this.updateAverageDeliveryTimeInterval)
        this.updateAverageDeliveryTimeInterval = null
      }
    }
  }
}
</script>
